var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTargetArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m20.81 28.08a12.86 12.86 0 0 1 -4.81.92 13 13 0 1 1 13-13 12.86 12.86 0 0 1 -.92 4.81.5.5 0 0 0 .28.65.51.51 0 0 0 .65-.27 14 14 0 1 0 -7.82 7.81.5.5 0 0 0 -.38-.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.41 20.45a.49.49 0 0 0 .66-.24 9.84 9.84 0 0 0 .93-4.21 10 10 0 1 0 -10 10 9.84 9.84 0 0 0 4.21-.93.5.5 0 1 0 -.42-.9 9 9 0 1 1 4.38-4.38.49.49 0 0 0 .24.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.28 17.49a.51.51 0 0 0 .6-.38 5.1 5.1 0 0 0 .12-1.11 5 5 0 1 0 -5 5 5.1 5.1 0 0 0 1.11-.12.5.5 0 1 0 -.22-1 3.8 3.8 0 0 1 -.89.12 4 4 0 1 1 4-4 3.8 3.8 0 0 1 -.1.89.5.5 0 0 0 .38.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 22.08a.49.49 0 0 0 -.46-.14l-3.27.65-6.95-6.94a.49.49 0 1 0 -.7.7l6.94 7-.65 3.27a.52.52 0 0 0 .14.46l2.82 2.82a.51.51 0 0 0 .36.15h.14a.52.52 0 0 0 .35-.38l.55-2.67.05.05a.52.52 0 0 0 .35.14.54.54 0 0 0 .33-.19.51.51 0 0 0 0-.71v-.02l2.62-.52a.52.52 0 0 0 .38-.35.52.52 0 0 0 -.13-.5zm-2 6.41-2-2 .47-2.36 2 2zm1.18-3.07-2-2 2.33-.42 2 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTargetArrow);
export default __webpack_public_path__ + "static/media/icon-target-arrow.f096abda3abbb56b979309809081c52e.svg";
export { ForwardRef as ReactComponent };